import Quote from "./quote";
 
const pdfDocuments = {
  "quote": Quote,
};

export default pdfDocuments;